var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-upload"},[_c('a-progress',{attrs:{"percent":_vm.percent,"size":"small"}}),(_vm.percent!=100)?_c('p',[_vm._v("上传速度: "+_vm._s(_vm.speed + 'kb/s'))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }